import React from 'react';
import { tomos } from '../data/content';
export function MethodSection() {
  return <section className="w-full bg-zinc-950 py-16 lg:py-24" aria-labelledby="metodo-titulo" data-id="element-70" data-mp="7tl9xjirafy1">
      <div className="mx-auto max-w-6xl px-6" data-id="element-71" data-mp="2tyxhcar53qa">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center lg:gap-16" data-id="element-72" data-mp="2v0ctsyswcdt">
          <div data-id="element-73" data-mp="3uzcl8x5ivfd9">
            <h2 id="metodo-titulo" className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-74" data-mp="3uzm3fykbsi8e">
              Presentamos <span className="text-amber-400" data-id="element-75" data-mp="ql4dbrgozw0l">Boxeo 360</span>: de profe a referente
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-zinc-300" data-id="element-76" data-mp="lrrzmcdjx9mm">
              No es solo información: es una estructura de 6 tomos diseñada para elevar el nivel de
              tus clases desde la próxima semana.
            </p>
          </div>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/2f7d8984-c00f-4ec7-8a07-a8be683e57fb.jpg" alt="Página interior del manual con diagramas de técnica junto a una planilla de planificación" className="w-full rounded-lg shadow-2xl shadow-black/70 ring-1 ring-zinc-800" data-id="element-77" data-mp="19ixfgrjhs1wx" />
        </div>

        <ol className="mt-14 border-t border-zinc-800" data-id="element-78" data-mp="1lc5rhknuc29s">
          {tomos.map(tomo => <li key={tomo.numero} className="grid grid-cols-[auto_1fr] gap-x-5 gap-y-1 border-b border-zinc-800 py-6 sm:grid-cols-[auto_20rem_1fr] sm:items-baseline sm:gap-x-8" data-id="element-79" data-mp="1q9xwngdhxkvx">
              <span className="font-display text-2xl leading-none text-amber-400" aria-hidden="true" data-id="element-80" data-mp="1h8rc8w7q7pxe">
                {tomo.numero}
              </span>
              <h3 className="text-lg font-semibold text-white" data-id="element-81" data-mp="17bv3cpdx11sb">
                <span className="sr-only" data-id="element-82" data-mp="2wrkyzidoecj5">Tomo {tomo.numero}: </span>
                {tomo.titulo}
              </h3>
              <p className="col-start-2 text-base leading-relaxed text-zinc-400 sm:col-start-3" data-id="element-83" data-mp="31r7drw95k0u2">
                {tomo.bajada}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}